<template>
  <v-dialog v-model="ModalToSIMASN" persistent max-width="40%">
    <v-card>
      <v-card-title class="headline"> Sinkron Data Ke IDASN? </v-card-title>
      <v-card-text>
        Data penghargaan yang anda pilih akan disalin ke data penghargaan di
        IDASN!
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" small depressed @click="ModalToSIMASN = false">
          Batal
        </v-btn>
        <v-btn
          color="primary"
          small
          depressed
          :loading="lbtn"
          :disabled="lbtn"
          @click="toSIMASN()"
        >
          Ya
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Cookie from "@/helper/cookie.js";
import Auth from "@/helper/auth.js";

import modal_tosimasnState from "@/store/asn/rwpangkat/modal_to_simasn";
import refreshView from "@/store/asn/rwpangkat/viewRwpangkat";

export default {
  data: () => ({
    token: Cookie.get("token"),
    lbtn: false,
  }),

  computed: {
    ModalToSIMASN: {
      get() {
        return modal_tosimasnState.state.ModalToSIMASN;
      },

      set(value) {
        modal_tosimasnState.commit("toggleModal", value);
      },
    },

    item: {
      get() {
        return modal_tosimasnState.state.rwpangkat;
      },
    },
  },

  methods: {
    toSIMASN() {
      this.lbtn = true;

      let data = {
        golongan: {
          id: this.item.golongan.id,
          tmt: this.item.golongan.tmt,
        },
        pertekBkn: {
          nomor: this.item.pertekBkn.nomor,
          tanggal: this.item.pertekBkn.tanggal,
        },
        suratKeputusan: {
          pejabat: this.item.suratKeputusan.pejabat,
          nomor: this.item.suratKeputusan.nomor,
          tanggal: this.item.suratKeputusan.tanggal,
        },
        jumlahKredit: {
          utama: this.item.jumlahKredit.utama,
          tambahan: this.item.jumlahKredit.tambahan,
        },
        masaKerjaGolongan: {
          tahun: this.item.masaKerjaGolongan.tahun,
          bulan: this.item.masaKerjaGolongan.bulan,
        },
        jenisKP: {
          id: this.item.jenisKP.id,
        },
        gajiPokok: "0",
      };

      const url =
        process.env.VUE_APP_ASN + "golongan/nip/" + this.$route.params.id;

      this.http
        .post(url, data, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((response) => {
          this.lbtn = false;
          if (response.data.success) {
            refreshView.commit("refreshData", true);
            refreshView.commit("alert", response.data.message);
            refreshView.commit("berhasilAlert", true);
            refreshView.commit("gagalAlert", false);
            refreshView.commit("success", response.data.success);
          } else {
            refreshView.commit("refreshData", true);
            refreshView.commit("alert", response.data.message);
            refreshView.commit("gagalAlert", true);
            refreshView.commit("berhasilAlert", false);
            refreshView.commit("success", response.data.success);
          }

          this.closeModal();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            Auth.logout(this.token);
          } else if (error.response) {
            this.lbtn = false;
            console.log(error.response.status);
          } else {
            this.lbtn = false;
            console.log("Error", error.message);
          }
        });
    },

    closeModal() {
      this.ModalToSIMASN = false;
    },
  },
};
</script>
